import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Badge } from "@/components/ui/badge";
import { fmtEUR, fmtDate } from "@/lib/format";
import { GitCommitHorizontal } from "lucide-react";

// Teilabrechnungen: all settlement lines for one contract aggregated into a
// Soll-Ist balance with a running cumulative (Verlauf).
export function ReconcileDetailDrawer({ contractId, onClose }) {
  const { data } = useQuery({ queryKey: ["mf-recon-detail", contractId], queryFn: async () => (await api.get(`/mobilfunk/reconciliation/${contractId}`)).data, enabled: !!contractId });
  return (
    <Sheet open={!!contractId} onOpenChange={(o) => !o && onClose()}>
      <SheetContent className="w-full overflow-y-auto sm:max-w-lg" data-testid="recon-detail-drawer">
        <SheetHeader><SheetTitle className="flex items-center gap-2"><GitCommitHorizontal className="h-4 w-4" />{data?.customer_name}</SheetTitle></SheetHeader>
        {data && (
          <div className="mt-4 space-y-4">
            <div className="grid grid-cols-3 gap-2 text-center">
              <div className="rounded-lg border border-border p-3"><div className="text-xs text-muted-foreground">Soll</div><div className="font-semibold">{fmtEUR(data.soll)}</div></div>
              <div className="rounded-lg border border-border p-3"><div className="text-xs text-muted-foreground">Ist</div><div className="font-semibold">{fmtEUR(data.ist)}</div></div>
              <div className="rounded-lg border border-border p-3"><div className="text-xs text-muted-foreground">Differenz</div><div className={`font-semibold ${data.difference < 0 ? "text-red-600" : data.difference > 0 ? "text-sky-600" : ""}`}>{fmtEUR(data.difference)}</div></div>
            </div>
            <div>
              <div className="mb-1.5 text-xs font-semibold uppercase tracking-wide text-muted-foreground">Verlauf ({data.line_count} Positionen)</div>
              {data.verlauf.length === 0 ? <div className="text-sm text-muted-foreground">Noch keine Abrechnungspositionen zugeordnet.</div>
                : <div className="space-y-1.5">{data.verlauf.map((v) => (
                  <div key={v.id} className="flex items-center justify-between rounded-md border border-border px-3 py-2 text-sm" data-testid="verlauf-line">
                    <div><div className="font-medium">{v.abrechnungsnummer || "—"} <span className="text-xs text-muted-foreground">({v.direction})</span>{v.is_duplicate && <Badge className="ml-1.5 bg-red-500/10 text-red-700 dark:text-red-300 border-red-500/20 text-[10px]">doppelt</Badge>}</div>
                      <div className="text-xs text-muted-foreground">{v.booking_date ? fmtDate(v.booking_date) : "—"} · {v.commission_ref || "—"}</div></div>
                    <div className="text-right"><div className={v.signed < 0 ? "text-red-600" : ""}>{fmtEUR(v.signed)}</div><div className="text-xs text-muted-foreground">Σ {fmtEUR(v.cumulative)}</div></div>
                  </div>
                ))}</div>}
            </div>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
